module.exports = {"tag":"v0.0.2-4-g6e324bf"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 355
// module chunks = 1